module.exports = __webpack_public_path__ + "img/ert-alto.b81ba9de.jpg";